import React , {Component} from 'react';

import NumberFormat from 'react-number-format';

class Food2Card extends Component{

    constructor(props) {
        super(props);

    }



    render(){
        const {  object , onAddToCartClicked , onRemoveFromCartClicked  , count , onRemoveProductFromCartClicked} = this.props

        return(
            <div className="food-2 b-row no-gutters row-eq-height justify-content-between">

                <div className="b-col-auto">


                    <div className="text-container">

                        <h5 className="title">
                            {object.title_fa}
                        </h5>

                        <button onClick={onRemoveProductFromCartClicked} className="btn btn-outline-danger btn-custom-2">حذف</button>





                    </div>



                </div>

                <div className="b-col-auto text-left">

                    <div className="text-center">
                        <p className="price text-center">
                            <NumberFormat value={object.price - (object.price * object.food_discount / 100)} displayType={'text'} thousandSeparator={true}  />
                            تومان
                        </p>
                    </div>
                    <div className={count > 0 ? `stepper order-count` : `stepper` } >
                        <div className="stepper-button-minus" onClick={onRemoveFromCartClicked}>

                        </div>
                        <div className="stepper-input-wrap">
                            <input type="text" value={count} readOnly={true} />
                        </div>
                        <div className="stepper-button-plus" onClick={onAddToCartClicked}>

                        </div>
                    </div>

                </div>


            </div>
        )

    }
}

export default Food2Card;